import { defineFcm } from '../shared/factory';

export const FCM_SIGNATURE_THERMOMETER = defineFcm('signature_thermometer').asBoolean().withDefault(false).toConfig();
